import { useState } from "react";
import AsyncSelect from "react-select/async";
import PropTypes from "prop-types";

export const EditSelects = ({
  cacheOptions,
  isSearchable,
  className,
  required,
  onChange,
  value,
  onFocus,
  loadOptions,
  defaultOptions,
}) => {
  
  const [edit, setEdit] = useState(false);

  const handleChange = (newValue) => {
    setEdit(false);
    onChange(newValue); // Call onChange with the new value
  };

  const handleMenuClose = () => {
    setEdit(false); // Set edit to false when the menu is closed
  };

  return (
    <>
      {edit ? (
        <AsyncSelect
          cacheOptions={cacheOptions}
          isSearchable={isSearchable}
          required={required}
          value={value}
          className={className}
          onChange={handleChange} // Use handleChange instead of onBlur
          onFocus={onFocus}
          loadOptions={loadOptions}
          defaultOptions={defaultOptions}
          onMenuClose={handleMenuClose} // Add onMenuClose event handler
        />
      ) : (
        <>
          <div className="text-left editable-pointer-events" onClick={() => setEdit(true)}>
            {value.value}
          </div>
        </>
      )}
    </>
  );
};

EditSelects.propTypes = {
  onChange: PropTypes.func.isRequired, // Make onChange required
  onFocus: PropTypes.func,
  loadOptions: PropTypes.func,
  defaultOptions: PropTypes.bool,
};
